// extracted by mini-css-extract-plugin
export default {"container":"styles_container__bX5Bf","content":"styles_content__r-au9"};